<template lang="pug">
  .page-container
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container
      AddressList
</template>

<script>
import AddressList from "../../components/common/address-list";

export default {
  components: {
    AddressList
  },
  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "userinfo" },
          disabled: false,
          text: this.$t("nav.userInfo")
        },
        {
          to: { name: "address" },
          disabled: true,
          text: this.$t("nav.addressList")
        }
      ];
    }
  }
};
</script>
<style scoped lang="sass" src="./list.sass"></style>
